import IconButton from '@mui/material/IconButton';
import HistoryIcon from '@mui/icons-material/History';
import LockIcon from '@mui/icons-material/Lock';
import NoEncryptionIcon from '@mui/icons-material/NoEncryption';
import { Box, Typography } from '@mui/material';


export default function EditRowButtons({ ...params }){

    let formattedName = params.formattedName
    let errorState = params.errorState
    let disabledState = params.disabledState
    let handleLockClick = params.handleLockClick
    let handleRevertClick = params.handleRevertClick

    return (
        <>
            <Box id={'EditRowButtonsBox'}>
                {disabledState === true ? (
                    <IconButton color={'success'} onClick={() => handleLockClick(formattedName)} id={'Unlockbutton'}>
                        <NoEncryptionIcon id={'UnlockIcon'}/>
                    </IconButton>
                ) : (
                    <IconButton color='success' onClick={() => handleLockClick(formattedName)} id={'Lockbutton'}>
                        <LockIcon id={'LockIcon'}/>
                    </IconButton>
                )}

                <IconButton color="error" onClick={(event) => handleRevertClick(event)} id={'RevertButton'}>
                    <HistoryIcon id={"RevertIcon"}/>
                </IconButton>

                {errorState && (
                    <Typography color="error" textAlign={'center'}>Invalid</Typography>
                )}
            </Box>
        </>
    )
}
